/**
 * HTTP レスポンスエラー
 */
export default class ResponseError extends Error {
	constructor(
		message: string,
		public readonly response: Response,
	) {
		super(message);
	}
}
